import request from "@/utils/request";

export default function agentEditDeviceBaseInfo(data) {
    return request({
        url: `/device/device/agentEditDeviceBaseInfo/`,
        method: 'post',
        data,
    })
}
